import React, { useState, useEffect } from "react";
import { Container, Row, Col, Form, Button, Spinner, Alert } from "react-bootstrap";
import { useParams, useNavigate } from "react-router-dom";
import api from "../services/api";
import "./AddPurchase.css";

const EditProduct = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: "",
    supplier_id: "",
    unit_id: "",
    hsn_code: "",
    is_inhouse_usage: false,
    // purchase_rate: ""
    // opening_stock: ""
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [fetching, setFetching] = useState(true);
  const [submitError, setSubmitError] = useState("");
  const [suppliers, setSuppliers] = useState([]);
  const [units, setUnits] = useState([]);

  // Fetch product data and dropdowns
  useEffect(() => {
    if (id) {
      fetchProductData();
      fetchDropdownData();
    }
  }, [id]);

  const fetchProductData = async () => {
    try {
      setFetching(true);
      const response = await api.post("/product_detail.php", { id });
      
      if (response.data.head.code === 200) {
        const product = response.data.body;
        setFormData({
          name: product.name,
          supplier_id: product.supplier_id,
          unit_id: product.unit_id,
          hsn_code: product.hsn_code,
          is_inhouse_usage: product.is_inhouse == 1 ? true : false
          // purchase_rate: product.purchase_rate
          // opening_stock: product.opening_stock
        });
      } else {
        setSubmitError("Product not found");
      }
    } catch (err) {
      console.error("Error fetching product:", err);
      setSubmitError("Failed to load product data");
    } finally {
      setFetching(false);
    }
  };

  const fetchDropdownData = async () => {
    try {
      // Fetch suppliers
      const suppliersResponse = await api.post("/supplier_list.php", {});
      if (suppliersResponse.data.head.code === 200) {
        setSuppliers(suppliersResponse.data.body);
      }

      // Fetch units
      const unitsResponse = await api.post("/unit_list.php", {});
      if (unitsResponse.data.head.code === 200) {
        setUnits(unitsResponse.data.body);
      }
    } catch (err) {
      console.error("Error fetching dropdown data:", err);
      // Fallback to sample data if API fails
      setSuppliers([
        { id: 1, name: "ABC Suppliers" },
        { id: 2, name: "XYZ Traders" },
        { id: 3, name: "Global Imports" },
        { id: 4, name: "Local Wholesalers" }
      ]);
      setUnits([
        { id: 1, name: "Piece" },
        { id: 2, name: "Kilogram" },
        { id: 3, name: "Meter" },
        { id: 4, name: "Liter" },
        { id: 5, name: "Box" },
        { id: 6, name: "Packet" },
        { id: 7, name: "Bottle" },
        { id: 8, name: "Carton" }
      ]);
    }
  };

  // const handleChange = (e) => {
  //   const { name, value } = e.target;
  //   setFormData((prev) => ({ ...prev, [name]: value }));
  // };
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));

    // Optional: log checkbox value
    if (type === "checkbox") {
      console.log(name, checked);
    }
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.name.trim()) newErrors.name = "Product Name is required";
    if (!formData.supplier_id) newErrors.supplier_id = "Supplier is required";
    if (!formData.unit_id) newErrors.unit_id = "Unit is required";
    if (!formData.hsn_code.trim()) newErrors.hsn_code = "HSN Code is required";
    // if (!formData.purchase_rate || isNaN(formData.purchase_rate) || formData.purchase_rate <= 0) 
    //   newErrors.purchase_rate = "Valid Purchase Rate is required";
    // if (!formData.opening_stock || isNaN(formData.opening_stock) || formData.opening_stock < 0) 
    //   newErrors.opening_stock = "Valid Opening Stock is required";
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }

    try {
      setLoading(true);
      setSubmitError("");
      
      const payload = {
        id: id,
        name: formData.name,
        supplier_id: formData.supplier_id,
        unit_id: formData.unit_id,
        hsn_code: formData.hsn_code,
        is_inhouse: formData.is_inhouse_usage ? 1 : 0
        // purchase_rate: formData.purchase_rate
        // opening_stock: formData.opening_stock
      };

      console.log("Updating product with payload:", payload);
      
      const response = await api.post("/product_edit.php", payload);
      
      if (response.data.head.code === 200) {
        alert("Product updated successfully!");
        navigate("/productlist");
      } else {
        setSubmitError(response.data.head.msg || "Failed to update product");
      }
    } catch (err) {
      console.error("Error updating product:", err);
      setSubmitError("Failed to update product. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const renderError = (field) =>
    errors[field] ? <div className="text-danger small mt-1">{errors[field]}</div> : null;

  if (fetching) {
    return (
      <Container className="mt-4">
        <div className="text-center py-5">
          <Spinner animation="border" role="status">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
          <p className="mt-3">Loading product data...</p>
        </div>
      </Container>
    );
  }

  return (
    <Container className="mt-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h4 className="mb-0">Edit Product</h4>
        <Button className="btn-top" onClick={() => navigate("/productlist")}>Back</Button>
      </div>

      {submitError && (
        <Alert variant="danger" className="mb-3">
          {submitError}
        </Alert>
      )}

      <Form onSubmit={handleSubmit} noValidate>
        <Row className="g-3">
          <Col lg={6} md={6} sm={12}>
            <Form.Group>
              <Form.Label>Product Name</Form.Label>
              <Form.Control
                name="name"
                type="text"
                value={formData.name}
                onChange={handleChange}
                placeholder="Enter Product Name"
                isInvalid={!!errors.name}
              />
              {renderError("name")}
            </Form.Group>
          </Col>

          <Col lg={6} md={6} sm={12}>
            <Form.Group>
              <Form.Label>Supplier</Form.Label>
              <Form.Select
                name="supplier_id"
                value={formData.supplier_id}
                onChange={handleChange}
                isInvalid={!!errors.supplier_id}
              >
                <option value="">Select Supplier</option>
                {suppliers.map((supplier) => (
                  <option key={supplier.id} value={supplier.id}>
                    {supplier.name}
                  </option>
                ))}
              </Form.Select>
              {renderError("supplier_id")}
            </Form.Group>
          </Col>

          <Col lg={4} md={4} sm={12}>
            <Form.Group>
              <Form.Label>Unit</Form.Label>
              <Form.Select
                name="unit_id"
                value={formData.unit_id}
                onChange={handleChange}
                isInvalid={!!errors.unit_id}
              >
                <option value="">Select Unit</option>
                {units.map((unit) => (
                  <option key={unit.id} value={unit.id}>
                    {unit.name}
                  </option>
                ))}
              </Form.Select>
              {renderError("unit_id")}
            </Form.Group>
          </Col>

          <Col lg={4} md={4} sm={12}>
            <Form.Group>
              <Form.Label>HSN Code</Form.Label>
              <Form.Control
                name="hsn_code"
                type="text"
                value={formData.hsn_code}
                onChange={handleChange}
                placeholder="Enter HSN Code"
                isInvalid={!!errors.hsn_code}
              />
              {renderError("hsn_code")}
            </Form.Group>
          </Col>

          <Col lg={4} md={4} sm={12}>
                      <Form.Group>
                        <Form.Label></Form.Label>
                        <Form.Check
                          type="checkbox"
                          label="Is Inhouse Usage"
                          name="is_inhouse_usage"
                          className="custom-checkbox"
                          checked={formData.is_inhouse_usage}
                          onChange={handleChange}
                        />
                      </Form.Group>
                    </Col>

          {/* <Col lg={6} md={6} sm={12}>
            <Form.Group>
              <Form.Label>Purchase Rate (₹)</Form.Label>
              <Form.Control
                name="purchase_rate"
                type="number"
                step="0.01"
                value={formData.purchase_rate}
                onChange={handleChange}
                placeholder="Enter Purchase Rate"
                isInvalid={!!errors.purchase_rate}
              />
              {renderError("purchase_rate")}
            </Form.Group>
          </Col> */}

          {/* <Col lg={6} md={6} sm={12}>
            <Form.Group>
              <Form.Label>Opening Stock</Form.Label>
              <Form.Control
                name="opening_stock"
                type="number"
                value={formData.opening_stock}
                onChange={handleChange}
                placeholder="Enter Opening Stock"
                isInvalid={!!errors.opening_stock}
              />
              {renderError("opening_stock")}
            </Form.Group>
          </Col> */}
        </Row>

        <div className="d-flex justify-content-end mt-4 gap-2">
          <Button 
            type="submit" 
            className="btn-submit" 
            disabled={loading}
          >
            {loading ? (
              <>
                <Spinner as="span" animation="border" size="sm" className="me-2" />
                Updating...
              </>
            ) : (
              "Update Product"
            )}
          </Button>
          <Button 
            type="button" 
            className="btn-top" 
            onClick={() => navigate("/productlist")}
            disabled={loading}
          >
            Cancel
          </Button>
        </div>
      </Form>
    </Container>
  );
};

export default EditProduct;